module.exports = __webpack_public_path__ + "assets/priceoff4.jpg?e1d0210b47f068dddf4216649da3be45";